<div class="col-md-6 col-12">
  <ng-container
    *ngTemplateOutlet="imageSelector; context: imageSelectorIdFront"
  ></ng-container>
</div>
<div class="col-md-6 col-12">
  <ng-container
    *ngTemplateOutlet="imageSelector; context: imageSelectorIdBack"
  ></ng-container>
</div>

<ng-template #imageSelector let-controlName="controlName" let-label="label">
  <ng-container *ngIf="getFormControlByName(controlName) as control">
    <form-image-selector
      [label]="label | translate"
      [options]="imageSelectorOptions"
      [formControl]="control"
    ></form-image-selector>
    <mat-error
      *ngIf="control?.touched && control?.hasError('required')"
      translate
    >
      forms.errors.field-required
    </mat-error>
  </ng-container>
</ng-template>